module.exports = __webpack_public_path__ + "static/androidCheckPenaltiesAndGetProtocol-e8bafb6b5af2e7f671107759b9210cb5.jpeg";